(() => {
  // Der Theme-Kopf klebt selbst oben und ist je nach Breite verschieden hoch.
  // Ohne Messung verschwindet das Verzeichnis dahinter.
  const kopfhoehe = () => {
    let hoch = 0;
    for (const el of document.querySelectorAll('header, .shopify-section-header, [class*="header"]')) {
      const cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      const r = el.getBoundingClientRect();
      if (r.height > 10 && r.top <= 1) hoch = Math.max(hoch, r.height);
    }
    return hoch;
  };

  const abstandSetzen = () => {
    const h = kopfhoehe();
    if (!h) return;
    const wert = Math.round(h + 24) + 'px';
    document.documentElement.style.setProperty('--md-blog-sticky-top', wert);
    document.documentElement.style.setProperty('--md-blog-anchor-offset', wert);
  };

  abstandSetzen();
  window.addEventListener('resize', abstandSetzen, { passive: true });
  window.addEventListener('load', abstandSetzen, { once: true });

  const nav = document.querySelector('.md-toc');
  const list = document.querySelector('.md-toc-list');
  const article = document.querySelector('.md-article') || document.querySelector('article');

  if (nav && list && article) {
    const headings = [...article.querySelectorAll('h2[id], h3[id]')];
    if (!headings.length) {
      nav.hidden = true;
      const layout = nav.closest('.md-article-layout');
      if (layout) layout.classList.add('md-no-toc');
    } else {
      const links = new Map();
      const fragment = document.createDocumentFragment();
      for (const heading of headings) {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'md-toc-link';
        link.dataset.level = heading.tagName === 'H3' ? '3' : '2';
        link.href = '#' + heading.id;
        link.textContent = heading.dataset.toc || heading.textContent.trim();
        if (heading.dataset.toc) link.title = heading.textContent.trim();
        item.appendChild(link);
        fragment.appendChild(item);
        links.set(heading.id, link);
      }
      list.appendChild(fragment);

      const visible = new Set();
      let zuletzt = null;

      const setActive = () => {
        let treffer = headings.find((heading) => visible.has(heading.id));
        if (!treffer) {
          const grenze = (parseFloat(getComputedStyle(document.documentElement)
            .getPropertyValue('--md-blog-anchor-offset')) || 100) + 10;
          for (const heading of headings) {
            if (heading.getBoundingClientRect().top <= grenze) treffer = heading;
            else break;
          }
        }
        if (!treffer) treffer = zuletzt;
        if (!treffer) return;
        zuletzt = treffer;
        for (const link of links.values()) link.classList.remove('is-active');
        const aktiv = links.get(treffer.id);
        if (!aktiv) return;
        aktiv.classList.add('is-active');
        aktiv.setAttribute('aria-current', 'true');
        for (const link of links.values()) {
          if (link !== aktiv) link.removeAttribute('aria-current');
        }
        if (nav.scrollHeight > nav.clientHeight + 4) {
          const oben = aktiv.offsetTop - nav.clientHeight / 2;
          nav.scrollTo({ top: Math.max(0, oben), behavior: 'smooth' });
        }
      };

      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) visible.add(entry.target.id);
          else visible.delete(entry.target.id);
        }
        setActive();
      }, { rootMargin: '-100px 0px -65% 0px', threshold: 0 });
      for (const heading of headings) observer.observe(heading);
      setActive();

      // Zweiter Weg: scrollend feuert einmal je Scrollvorgang, nicht je Bild.
      // Der Beobachter allein reicht nicht, wenn der Browser ihn drosselt.
      if ('onscrollend' in window) {
        document.addEventListener('scrollend', setActive, { passive: true });
      }
    }

    // Auf schmalen Bildschirmen bleibt das Verzeichnis zugeklappt, ab 1000px offen
    const breit = window.matchMedia('(min-width: 1000px)');
    const anpassen = () => { nav.open = breit.matches; };
    anpassen();
    breit.addEventListener('change', anpassen);
    list.addEventListener('click', (e) => {
      if (!breit.matches && e.target.closest('.md-toc-link')) nav.open = false;
    });
  }

  const price = (cents) => (cents / 100).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' €';

  for (const card of document.querySelectorAll('.md-product[data-handle]')) {
    const target = card.querySelector('.md-product-price');
    if (!target) continue;
    fetch('/products/' + card.dataset.handle + '.js')
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then((product) => {
        // Preisauszeichnung wie im Theme, damit die Karte sich einfuegt
        target.innerHTML = '';
        const preis = document.createElement('sale-price');
        preis.className = 'text-subdued';
        preis.textContent = price(product.price);
        target.appendChild(preis);
        target.dataset.price = product.price;
        if (product.compare_at_price && product.compare_at_price > product.price) {
          const vorher = document.createElement('compare-at-price');
          vorher.className = 'text-subdued line-through';
          vorher.textContent = price(product.compare_at_price);
          target.appendChild(vorher);
        }
        const name = card.querySelector('.md-product-title');
        if (name && !name.textContent.trim()) name.textContent = product.title;
        const bild = card.querySelector('img');
        if (bild && !bild.getAttribute('alt')) bild.alt = product.title;
      })
      .catch(() => {});
  }
})();
